import { render, staticRenderFns } from "./ot-select-document-dialog.vue?vue&type=template&id=75e3cd9c&scoped=true&"
import script from "./ot-select-document-dialog.vue?vue&type=script&lang=ts&"
export * from "./ot-select-document-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./ot-select-document-dialog.vue?vue&type=style&index=0&id=75e3cd9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e3cd9c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
